import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** Snow is soft (matte) blob voxels: the blob SDF surface rounds and merges them into drifts. */
export const SNOW_KIND = liquidKind('blob', { material: 'soft', defaultColor: 0xf4f8fc })

/** One input's snow and its settling, one event per pointer event; a whole press is one undo step. */
export const SNOW_SETTLE = liquidSettleEvent('experience.snow.settle', SNOW_KIND)

/** Reducer handlers for Snow (`experience.snow.*`). */
export const eventHandlers = SNOW_SETTLE.handlers
